import { render, staticRenderFns } from "./scraping_actions.vue?vue&type=template&id=0f480bd0&scoped=true"
import script from "./scraping_actions.vue?vue&type=script&lang=js"
export * from "./scraping_actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f480bd0",
  null
  
)

export default component.exports